import { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'
import { PanelHeader } from '@ui2/structure'
import { IFC_MODE_HEADERS } from '../../constants'

interface Props {
  /** The active `ifcMode` — its title/description header is looked up from `IFC_MODE_HEADERS`. */
  mode: string
  children?: ReactNode
}

/**
 * Wraps an IFC import drawer panel with a header (tool title + description, divider) mirroring the
 * guided-workflow step header, followed by the padded panel content.
 */
const IFCModeDrawer = ({ mode, children }: Props): ReactElement => {
  const header = IFC_MODE_HEADERS[mode]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      {header && <PanelHeader title={header.title} description={header.description} />}
      <Box sx={({ palette }) => ({ flex: 1, p: 1.5, backgroundColor: palette.grey[100] })}>
        {children}
      </Box>
    </Box>
  )
}

export default IFCModeDrawer
